import ActionSheet from './ActionSheet';
import ActionSheetContext from './ActionSheetContext';
import Item from './ActionSheetItem';
import Menu from './ActionSheetMenu';

ActionSheet.Menu = Menu;
ActionSheet.Item = Item;
ActionSheet.Trigger = ActionSheetContext.Consumer;

export default ActionSheet;
